import { defineComponent as _defineComponent } from 'vue'
import {useConfigurationStore} from "@/store/configuration.store";
import {computed, nextTick, ref} from "vue";
import {useBlockStore} from "@/store/block.store";
import { changeTitle } from "@/utils/title-changer";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentBlockchain',
  setup(__props, { expose: __expose }) {
  __expose();


const selectionView = ref(false);
const selectionView2 = ref(false);
const configMap = computed(() => {return useConfigurationStore().getConfigList;});
const curentNetwork = computed(() => {
  return useConfigurationStore().getConfigName;
});

const onChange = (event: any) => {
  useConfigurationStore().setNetwork(event.target.value);
  changeTitle();
  nextTick(() => {
    resetAfterChange();
  });

};
const latestBlock = computed(() => useBlockStore().getLatestBlock);

function resetAfterChange(){
  selectionView2.value = false;
  selectionView.value = false;
}

const __returned__ = { selectionView, selectionView2, configMap, curentNetwork, onChange, latestBlock, resetAfterChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})